import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api/api.service';
import { UmResearcher } from 'src/app/models/um-researcher';
import { Study } from 'src/app/models/study';
import { User } from '../../../models/user';

@Injectable({
  providedIn: 'root',
})
export class ResearcherService {
  getResearchers(): Observable<UmResearcher[]> {
    return this.apiService.get<UmResearcher[]>('/dashboard/researchers');
  }

  activateResearcher(researcherId: number): Observable<UmResearcher> {
    return this.apiService.put<UmResearcher>(`/dashboard/researcher_activate_deactivate/${researcherId}`, {
      active: true,
    });
  }

  blockResearcher(researcherId: number): Observable<UmResearcher> {
    return this.apiService.put<UmResearcher>(`/dashboard/researcher_activate_deactivate/${researcherId}`, {
      active: false,
    });
  }

  getResearcherStudies(researcherId: number): Observable<Study[]> {
    return this.apiService.post<Study[]>('/dashboard/researcher_studies', {
      id: researcherId,
    });
  }

  changeResearcherAccountType(researcherId: number, newType: string): Observable<UmResearcher> {
    return this.apiService.put<UmResearcher>(`/dashboard/researcher_account_type/${researcherId}`, {
      new_type: newType,
    });
  }

  changeResearcherStudyType(researcherId: number, studyType: string, checked: boolean): Observable<JSON> {
    return this.apiService.post<JSON>('/dashboard/researchers', {
      id: researcherId,
      type: studyType,
      checked,
    });
  }

  changeStudyTypeAccess(researcherId: number, studyType: string, checked: boolean): Observable<JSON> {
    return this.apiService.put<JSON>('/dashboard/researchers/block_all_studies', {
      researcher_id: researcherId,
      study_type: studyType,
      block: checked,
    });
  }

  changeResearcherStudyAccess(researcherId: number, studyId: number, block: boolean): Observable<JSON> {
    return this.apiService.put<JSON>('/dashboard/researchers/block_study', {
      researcher_id: researcherId,
      study_id: studyId,
      block,
    });
  }

  deleteStudy(studyId: number): Observable<JSON> {
    return this.apiService.delete<JSON>(`/dashboard/study/${studyId}`);
  }

  getResearcher(email: string): Observable<User> {
    return this.apiService.post<User>('/dashboard/researcher/get_researcher', {
      email,
    });
  }

  addStudyResearcher(studyId: number, researcher: User): Observable<User> {
    return this.apiService.post<User>(`/dashboard/study/${studyId}/researcher`, researcher);
  }

  updateStudyResearcher(studyId: number, researcher: User): Observable<User> {
    return this.apiService.put<User>(`/dashboard/study/${studyId}/researcher/${researcher?.id}`, researcher);
  }

  deleteStudyResearcher(studyId: number, researcherId: number): Observable<string> {
    return this.apiService.delete<string>(`/dashboard/study/${studyId}/researcher/${researcherId}`, {
      responseType: 'text',
    });
  }

  disableResearcherTFA(researcherId: number): Observable<UmResearcher> {
    return this.apiService.put<UmResearcher>(`/dashboard/researchers/${researcherId}/disable_tfa`, {});
  }

  constructor(private apiService: ApiService) {}
}
